var scope_0 = require('/Users/yangzhou/Documents/projects/stripe-express/itstripe-doc/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e28b2fbec77a83141977da91e1354307.js').default;export default
        Object.assign({}, scope_0 )
    